import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
        color: #ffffff; /* white text */
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #000000; /* black background */
        overflow-x: hidden;
    }

    a:hover {
        color: #b3b3b3; /* light gray on hover */
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: #1a1a1a; /* dark input background */
        color: #ffffff; /* white input text */
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: #000000;
            box-shadow: #ffffff 0px 0px 0px 1px; /* white focus outline */
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #ffffff; /* white headings */
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #d1d1d1; /* light gray text */
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #ffffff; /* white links */

        :hover {
            color: #b3b3b3; /* light gray hover */
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
        background: #000000; /* black drawer background */
        color: #ffffff; /* white drawer text */
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;